export const OWNERS = [
  { value: "Steven", label: "Steven" },
  { value: "Richard", label: "Richard" },
  { value: "Both", label: "Both" },
];

export const PRIORITY_LEVELS = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Critical", label: "Critical" },
];

export const PRIORITY_STATUS = [
  { value: "Not started", label: "Not started" },
  { value: "In progress", label: "In progress" },
  { value: "Blocked", label: "Blocked" },
  { value: "Complete", label: "Complete" },
];

export const BLOCKER_SEVERITY = PRIORITY_LEVELS;

export const BLOCKER_STATUS = [
  { value: "Open", label: "Open" },
  { value: "Being resolved", label: "Being resolved" },
  { value: "Resolved", label: "Resolved" },
];

export const DECISION_STATUS = [
  { value: "Awaiting decision", label: "Awaiting decision" },
  { value: "Under review", label: "Under review" },
  { value: "Decided", label: "Decided" },
];

export const AREAS = [
  { value: "Product", label: "Product" },
  { value: "Launch", label: "Launch" },
  { value: "Marketing", label: "Marketing" },
  { value: "Investors", label: "Investors" },
  { value: "Finance", label: "Finance" },
  { value: "General", label: "General" },
];

export const priorityBadge = (level) =>
  ({ Low: "info", Medium: "info", High: "warning", Critical: "error" }[level] || "neutral");

export const statusBadge = (status) =>
  ({
    "Not started": "neutral",
    "In progress": "warning",
    Blocked: "error",
    Complete: "success",
    Open: "warning",
    "Being resolved": "info",
    Resolved: "success",
    "Awaiting decision": "warning",
    "Under review": "info",
    Decided: "success",
  }[status] || "neutral");
